/**
 * The Sites surface's route entry (`/sites`, `/sites/machines`,
 * `/sites/:siteId`). It picks the page from the route; the pages themselves
 * live beside it (JSS#1157, split out of the old pages/Deployments.tsx).
 */
import { useParams, useMatch } from 'react-router-dom';
import SitesList from './SitesList';
import SiteDetail from './SiteDetail';
import { MachineInventory } from './MachineInventory';

export default function SitesPage() {
  const { siteId } = useParams<{ siteId: string }>();
  // Router matching, not a string compare, so `/sites/machines/` is Machines too.
  const machines = useMatch('/sites/machines');

  if (siteId) {
    return <SiteDetail siteId={siteId} />;
  }

  if (machines) {
    return <MachineInventory />;
  }

  return <SitesList />;
}
